import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
// import cmmJs from './js/cmmJs.js'

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

import "../src/assets/layout.css"

createApp(App)
    .use(store)
    .use(router)
    // .use(cmmJs)
    .mount('#app')
